import React, { useEffect, useState } from 'react';
import { PolicyRow } from 'components/alf-design';
import { formats, customTypes } from 'utils';

const BillingSubtitles = ({ billing, ...insuredProps }) => {
  const [paymentPlan, setPaymentPlan] = useState(null);

  useEffect(() => {
    switch (billing.paymentPlan) {
      case 'SEMIANNUAL':
      case '2S':
      case '2F':
        setPaymentPlan('2 Pay');
        break;
      case 'QUARTERLY':
      case '4S':
      case '4F':
        setPaymentPlan('4 Pay');
        break;
      case 'ANNUAL':
      case 'FL':
        setPaymentPlan('Full Pay');
        break;
      default:
        setPaymentPlan(null);
        break;
    }
  }, [billing.paymentPlan]);

  return (
    <div className="mb-[16px]">
      <div className="grid grid-cols-2 gap-[12px] mb-[16px]">
        {paymentPlan && (
          <PolicyRow
            label="Payment Plan"
            value={paymentPlan}
            tooltip={
              !billing.autoPay
                ? 'To change your Payment Plan, please contact your agent.'
                : null
            }
            ariaLabel="Payment Information tooltip"
          />
        )}
        {billing.nextInstallmentAmount > 0 ? (
          <PolicyRow
            label="Next Payment Amount"
            value={formats.moneyFormat(billing.nextInstallmentAmount)}
          />
        ) : (
          insuredProps?.premium > 0 && (
            <PolicyRow
              label="Premium"
              value={formats.moneyFormat(insuredProps?.premium)}
              ariaLabel="fusionPremium"
              tooltip={
                insuredProps?.sameStatus
                  ? 'Slide Fusion consists of two policies. The amount shown is the combined premium.'
                  : null
              }
            />
          )
        )}
      </div>
      {billing.nextInstallmentAmount > 0 && (
        <div className="grid grid-cols-2 gap-[12px] mb-[16px]">
          <PolicyRow
            label="Next Payment Due Date"
            value={formats.dateFormat(billing.nextInstallmentDueDate)}
          />
          {insuredProps?.premium > 0 && (
            <PolicyRow
              label="Premium"
              value={formats.moneyFormat(insuredProps?.premium)}
              ariaLabel="fusionPremium"
              tooltip={
                insuredProps?.sameStatus
                  ? 'Slide Fusion consists of two policies. The amount shown is the combined premium.'
                  : null
              }
            />
          )}
        </div>
      )}
    </div>
  );
};

BillingSubtitles.propTypes = {
  billing: customTypes.billing,
};

export default BillingSubtitles;
